import {apiClient} from './client';
import {Availabilities,AvailabilityQuery} from "@/models/Availability";
import {AxiosResponse} from "axios";
import {AvailabilityBoat} from "@/models/Boat";

const baseUrl = "availability"

const handleParams = (searchParams, filtersOnly:boolean=false)=>{
    const params = new URLSearchParams();
    for (const key in searchParams) {

        if(filtersOnly && ['minPrice','maxPrice','minYear','maxYear','minWc','maxWc','maxCabins','minCabins','minBerths','maxBerths','minLength','maxLength'].indexOf(key) >=0){
            continue
        }

        if (!(key in searchParams)) {
            continue
        }

        if (!searchParams[key]) {
            continue
        }

        if ( typeof searchParams[key] === "object" && searchParams[key].length <=0 ) {
            continue
        }

        if ( typeof searchParams[key] === "number" && searchParams[key] <=0 ) {
            continue
        }


        params.append(key, searchParams[key]);
    }

    return params

}

export const searchAvailabilities = (searchParams:any,pageNum: number =0, filtersOnly:boolean =false): Promise<AxiosResponse<Availabilities>> => {

    let params = handleParams(searchParams,filtersOnly);
    let path = `${baseUrl}?${params}`

    if(pageNum !== null || pageNum > 0){
        path = `${baseUrl}?${params}&page=${pageNum}`;
    }

    return apiClient.get(path)

}


export const searchRecommendations = (searchParams: AvailabilityQuery): Promise<AxiosResponse<AvailabilityBoat[]>> => {


    let params = handleParams(searchParams);

    console.log("Params",searchParams,params)
    return apiClient.get(`/bundle?${params}`)
}
